export const baserUrl = 'https://hcv-portal-api.azurewebsites.net';
//export const baserUrl = 'http://127.0.0.1:8083';

export const baseUrl = baserUrl + '/api';

export const TEXT_HEADERS = (token: string | null) => {
    return {
        "Content-Type": "text/plain",
        "Authorization": `Bearer ${token}`
    };
};
export const JSON_HEADERS = (token: string | null) => {
    return {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`
    };
};
export const AUTH_HEADERS = (token: string | null) => {
    return {
        "Authorization": `Bearer ${token}`
    };
};

export interface Content {
    id: number;
    type: string;
    name: string;
    total: number;
    createdAt: string;
    updatedAt: string;
    ready: boolean;
    parentGroupId?: number;
}

export interface GroupInfo {
    id: number;
    name: string;
}

export interface Group {
    name: string;
    path: GroupInfo[];
    contentList: Content[];
}

export interface Portal {
    id: number;
    name: string;
}

export interface Package {
    id: number;
    name: string;
    description: string;
    keypoints: string;
    images: string;
    ready: boolean;
    files: PackageFile[];
    levels: string[];
    categories: string[];
    type: string;
    price: number;
}

export interface PackageFile {
    id: number;
    name: string;
    duration: number;
}

export interface Tag {
    id: number;
    name: string;
    predefined: boolean;
    readOnly: boolean;
}

export interface DrillFile {
    id: number;
    name: string;
    createdAt: string;
    updatedAt: string;
    updatedBy: string;
}

export interface FetchDrillsRequest {
    nameFilter?: string;
    orderBy: string;
    orderDirection: string;
    page: number;
}

export interface UpdateDrillRequest {
    name?: string;
    description?: string;
    keypoints?: string;
    stress?: number;
    technics?: number;
    tactics?: number;
    fun?: number;
    goalie?: number;
    offense?: number;
    defense?: number;
    levels?: string[];
    tags?: number[];
}

export interface FetchDrillsResponse {
    total: number;
    drills: DrillFile[];
}

export interface DrillFileDetails {
    id: number;
    name: string;
    description: string;
    keypoints: string;
    stress: number;
    technics: number;
    tactics: number;
    fun: number;
    goalie: number;
    offense: number;
    defense: number;
    levels: string[];
    tags: number[];
}

export interface User {
    id: number;
    email: string;
    accountType: string;
    license: string;
    role: string;

    name: string;
    biography: string;
    inviteSent: boolean;
    defaultPassword: string;
    owned: boolean;
}

export interface FetchUsersRequest {
    emailFilter?: string;
    orderBy: string;
    orderDirection: string;
    page: number;
}

export interface FetchUsersResponse {
    total: number;
    users: User[];
}

export interface OrgInfo {
    remainingSlotsCount: number;
    maxRemainingSlotsCount: number;
}

